<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">报价新增</span>
      </v-card-title>
      <v-card-text>
        <ul>
          <li>事業本部から作られた見積について必要がある時のみSJL担当にメール送信して、見積することを行う</li>

          <li>事業本部のユーザーから「フォワダー」と「通関業者」を弄られない</li>

          <li>有効期限：見積作成日より１ヶ月間とする</li>

          <li>物流業者を指定しない時に見積作成が業者中一番高い単価を利用して作成</li>
        </ul>
        <h3>处理Point</h3>
        <ol>
          <li>报价功能基本有SHARP的事业本部用户操作使用，有必要时才使用【見積書（依頼）メール送信】按钮发送通知Email给SJL相关担当进行报价编辑</li>
          <li>“事业本部”用户不能指定【承运人（フォワダー）】和【报关业者（通関業者）】（此两个项目只有SJL报价担当可以进行操作）</li>
          <li>报价需要有【有效期限】，该期限为【报价制成日】开始1个月有效</li>
          <li>【承运人】和【报关业者】未指定的情况下报价需要使用【单价Master】中满足相同计算条件的最高单价进行报价计算</li>
        </ol>
        <h3>处理逻辑要点：（仕様確認書（2.Shipping Advice）sheet内容对照）</h3>
        <ol>
          <li>报价的管理Key为【报价No.（見積NO.）】</li>
          <li>金额计算涉及外币的部分请参照【汇率Master】进行计算
            <ul>
              <li>※ 报价中的FOB商品价格（商品代金）的计算使用操作当月的【社内汇率（社内レート）】</li>
              <li>※ 报价中的运费（運賃）的计算使用操作当月的【海上航空运费换算汇率（海上航空運賃換算レート）】</li>
              <li>※ 报价中的保险费的计算使用操作前月的【平均TTS】汇率</li>
            </ul>
          </li>
          <li>“事业本部”用户不能指定【承运人（フォワダー）】和【报关业者（通関業者）】（此两个项目只有SJL报价担当可以进行操作）</li>
          <li>报价书作成时使用有效的运费单价（单价Master）来进行费用计算</li>
          <li>【再报价（再見積）】功能：对同一个报价No.的处理对象进行再计算的处理方式，计算的报价信息更新原来的报价数据</li>
          <li>再报价时【报价No.】需要追加3位的流水号来标注进行再报价的次数</li>
          <li>报价计算出的金额【事业本部】相关用户无法对其进行修改，修改只允许SJL有权限用户才可以进行</li>
          <li>报价中使用的Item（商品）一般以手输入为准，如果【Item master】中有相关商品请直接使用mater中数据，手输入的Item信息如果为新数据请直接保存到【Item Master】中</li>
          <li>如果运费master中没有对应的运费单价信息时报价金额为“0”且需用不同背景色显示，相关背景色的说明请在页面上进行标注，以便用户明确背景色的说明内容</li>
          <li>国内运费的计算只计算到达港至【纳入场所】间的运费</li>
          <li>报价依赖者需要明确（页面初期显示的依赖者为事业本部使用报价功能的用户信息，允许报价最初的生成用户修改</li>
          <li>报关费用（通関料金）有两种，一种是一般通关 7000；还有一种是特例通关：5000 报价时请使用最高单价计算</li>
          <li>诸挂取极料 计算方式：供应商（サプライヤー）单位按 B/L 单位 计算</li>
          <li>Air运费： 有最小计费金额，且有分计算单位区间设定单价的方式，通常按【计价单位】进行计算</li>
          <li>保险费：基本使用固定费率计算，计算按运输方式（Air，Sea）+贸易方式（建值）进行计算。有供应商使用不同税率，所以需要进行供应商单位的特例计算（可以考虑使用【保险费Master】进行设定。计算单位 为“B/L”单位
            <div style="margin-left:15px">
              方法： A: FOB单价 × 商品输入数 = FOB商品合计金额
              <br>B: （（FOB商品合计金额× 汇率（社内汇率）（日元换算额） + 海外运费及其他费用（日元换算额）） × 保险费率 × 1.1）÷（1 - （保险费率 × 1.1））
              小数点第一位四舍五入
            </div>
            <div>
              ※追加内容
              SJL佣金（SJLコミッション）：使用商品合计金额及佣金费率计算（佣金费率建议建立专门的Master维护，主要包括有效时间及特殊海外供应商单位的特殊费率
              方法：FOB商品合计金额 × 汇率（社内汇率）× 佣金费率
            </div>
          </li>
          <li>搬出手续费：按港口进行设定，计算单位为“B/L”单位</li>
          <li>P/O订单数量有SHARP SAP端管理，并通过I/F更新</li>
          <li>不同【事业本部】之前不能互相查询对方的报价信息</li>
          <li>一般报价功能由【事业本部】用户使用，只有在需要SJL相关人员介入时才通过手动委托邮件发送功能联系SJL担当参与报价操作</li>
          <li>报价有效期：报价制作开始1个月</li>
          <li>【事业本部】用户无法选在物流供应商（フォワダー）和报关业者</li>
          <li>报价制作时请使用单价Master中单价最高的单价进行报价计算</li>
        </ol>
        <h3>基本费用计算方式（参照）</h3>
        <ul>
          <li>A.需要建立【费用单价Master】（【費用単価（タリフ）】）</li>
          <li>B.【费用单价Master】中根据运输分段进行设置（国际运费 & 国内运费）</li>
          <li>C.Master设定条件：根据不同的物流供应商 按线路（【出发港】+【到达港】）及贸易方式 来区分，每个线路中设定不同的费用项目（可设定费用项目需要从【费用项目Master】中取得）
            <ul>
              <li>※Master中相同的费用项目可以根据不同的计算详细（如货柜尺寸等）进行复数行的Master数据添加</li>
              <li>※国内运输时，线路为（到达港或出发【纳入场所】+到达【纳入场所】）</li>
            </ul>
          </li>
          <li>D.费用计算规则
            <ol>
              <li>根据【出发港】+【到达港】 + 贸易方式 + 物流供应商 確定“线路”</li>
              <li>根据“计算单位”+“数量”等条件判断对应的项目单价</li>
              <li>计算所有该“线路”下的所有有效费用金额</li>
            </ol>
          </li>
          <li></li>
        </ul>
        <h3>输出物Point</h3>
        <ol>
          <li>该页面需要的主要输出物为2个
            <ul>
              <li>A. 输入成本试算书（輸入コスト試算書）</li>
              <li>B. 概算报价书（概算見積書）</li>
            </ul>
          </li>
          <li>两报表显示项目基本一致，主要区别在于【概算报价书】中不需要显示（商品总价 & 保险费用）</li>
        </ol>
        <h3>报价单号生成规则</h3>
        <ol>
          <li>报价单号生成请按以下规则
            <ul>
              <li>SJL（固定文字） + 事业本部代码（2位数）+ 年份个位数值（1位数）+流水号数值（5位数）</li>
              <li>共11位数值</li>
              <li>打印的两个表单“概算报价书”（Q)和“进口成本试算书”（T)上的报价单号分别再11位的报价单号基础上加上表单区分值 “Q"或“T"</li>
            </ul>
          </li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style scoped>
h3 {
  margin: 5px 0px;
}
</style>
